




























import { Component, Prop, Vue } from "vue-property-decorator";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

@Component({
  components: {
    swiper,
    swiperSlide
  }
})
export default class CellarImagesDialog extends Vue {
  loading = false;
  swiperOption: Object = {
    zoom: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  };

  @Prop({ default: [] }) private cellarImages!: any[];

  closeDialog() {
    this.$store.dispatch("app/closeDialog");
  }
}
